import { ErrorCodeEnum } from '@css-xp/ppc-types';
import { CCPVaidationError } from '@atlassian/temp-proxies';

/**
 * formatErrorMessage is a utility function that formats the error message based on the CCP error code.
 * The function takes an error code as an argument and returns an object with title and description properties.
 *
 * @param ccpErrorCode
 * @returns
 */
export function formatErrorMessage(ccpErrorCode?: string) {
  if (!ccpErrorCode) return null;

  const pendingInvoiceErrorMessage = {
    title: 'We’re unable to place the order',
    description: 'Subscriptions on the order have outstanding invoice actions. Still having trouble?',
  };

  const genericErrorMessage = {
    title: 'We’re unable to place the order',
    description: '',
  };

  /**
   * passing description string as blank for few error codes because description are `Contact Partner Service Desk for help`.
   * In this string, `Partner Service Desk` is an anchor tag that will be added in the UI.
   * Hence, appending the description string in the UI.
   */

  if (ccpErrorCode) {
    switch (ccpErrorCode) {
      case ErrorCodeEnum.CCP_PENDING_INVOICE_ORDER_TYPE_NOT_SUPPORTED:
        return pendingInvoiceErrorMessage;
      case ErrorCodeEnum.CCP_UNPAID_INVOICE:
        return pendingInvoiceErrorMessage;
      case ErrorCodeEnum.CCP_INVALID_ORDER_REQUEST_DATA:
        return genericErrorMessage;
      case ErrorCodeEnum.CCP_COUPLING_ERROR:
        return genericErrorMessage;
      case ErrorCodeEnum.CCP_ACCOUNT_MODIFICATION_TXA_SAME_AS_CURRENT_TXA:
        return genericErrorMessage;
    }
  }
  return null;
}

function findUniqueErrorMessage(items: CCPVaidationError['items']) {
  const errorCodes = new Set<string>();
  items.forEach((item: any) => {
    item.errors.forEach((error: any) => {
      errorCodes.add(error.errorCode);
    });
  });

  const errorMessageArr: string[] = [];

  Array.from(errorCodes).forEach((errorCode) => {
    const formattedErrorMessage = formatErrorMessage(errorCode);
    if (formattedErrorMessage && formattedErrorMessage.description) {
      errorMessageArr.push(formattedErrorMessage.description);
    }
  });

  if (errorMessageArr.length > 0) {
    return {
      title: 'We’re unable to place the order',
      description: errorMessageArr.join('. '),
    };
  }

  return null;
}

export function formatQuoteErrorMessage(error: CCPVaidationError) {
  const { items, code } = error;

  const errObjFromRootErrCode = formatErrorMessage(code);

  if (errObjFromRootErrCode) {
    return errObjFromRootErrCode;
  }

  return findUniqueErrorMessage(items);
}
